import { render, staticRenderFns } from "./shanxiSupervisonStudentlStatistics.vue?vue&type=template&id=52967d4c&scoped=true"
import script from "./shanxiSupervisonStudentlStatistics.vue?vue&type=script&lang=js"
export * from "./shanxiSupervisonStudentlStatistics.vue?vue&type=script&lang=js"
import style0 from "./shanxiSupervisonStudentlStatistics.vue?vue&type=style&index=0&id=52967d4c&prod&lang=less"
import style1 from "./shanxiSupervisonStudentlStatistics.vue?vue&type=style&index=1&id=52967d4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52967d4c",
  null
  
)

export default component.exports